export const BIKE_SCAN_TRIGGER_LOADING = "BIKE_SCAN_TRIGGER_LOADING";
export const BIKE_SCAN_TRIGGER_ERROR = "BIKE_SCAN_TRIGGER_ERROR";

export const BIKE_SCAN_TRIGGER_ADD = "BIKE_SCAN_TRIGGER_ADD";
export const BIKE_SCAN_TRIGGER_UPDATE = "BIKE_SCAN_TRIGGER_UPDATE";
export const BIKE_SCAN_TRIGGER_DELETE = "BIKE_SCAN_TRIGGER_DELETE";
export const BIKE_SCAN_TRIGGER_ACTIONS = "BIKE_SCAN_TRIGGER_ACTIONS";
export const BIKE_SCAN_TRIGGER_COUNT = "BIKE_SCAN_TRIGGER_COUNT";
export const BIKE_SCAN_TRIGGER_FILTERS = "BIKE_SCAN_TRIGGER_FILTERS";
export const BIKE_SCAN_TRIGGER_FILTERS_V2 = "BIKE_SCAN_TRIGGER_FILTERS_V2";
export const BIKE_SCAN_TRIGGER_LIST = "BIKE_SCAN_TRIGGER_LIST";
export const BIKE_SCAN_TRIGGER_SEARCH = "BIKE_SCAN_TRIGGER_SEARCH";
export const BIKE_SCAN_TRIGGER_SINGLE = "BIKE_SCAN_TRIGGER_SINGLE";



// WEBPACK FOOTER //
// ./src/actions/bike-scan-trigger/constants.js